import { render, staticRenderFns } from "./AdminSecurity.vue?vue&type=template&id=4c980c38"
import script from "./AdminSecurity.vue?vue&type=script&lang=js"
export * from "./AdminSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports